import { Button, ButtonGroup, Form } from "react-bootstrap";

const insertAroundSelection = (text, selectionStart, selectionEnd, before, after = before) => {
  const selected = text.slice(selectionStart, selectionEnd);
  const nextText = `${text.slice(0, selectionStart)}${before}${selected}${after}${text.slice(selectionEnd)}`;
  const cursorStart = selectionStart + before.length;
  const cursorEnd = cursorStart + selected.length;

  return { nextText, cursorStart, cursorEnd };
};

const prefixSelectedLines = (text, selectionStart, selectionEnd, prefixFactory) => {
  const lineStart = text.lastIndexOf("\n", selectionStart - 1) + 1;
  const lineEndIndex = text.indexOf("\n", selectionEnd);
  const lineEnd = lineEndIndex === -1 ? text.length : lineEndIndex;
  const selectedBlock = text.slice(lineStart, lineEnd);
  const lines = selectedBlock.split("\n");
  const prefixed = lines
    .map((line, index) => {
      const prefix = prefixFactory(index);
      if (line.trim().startsWith(prefix.trim())) return line;
      return `${prefix}${line}`;
    })
    .join("\n");

  return {
    nextText: `${text.slice(0, lineStart)}${prefixed}${text.slice(lineEnd)}`,
    cursorStart: lineStart,
    cursorEnd: lineStart + prefixed.length,
  };
};

export default function TaskDescriptionEditor({ value, onChange }) {
  const applyFormat = (format) => {
    const textarea = document.getElementById("task-description-editor");
    if (!textarea) return;

    const text = value || "";
    const { selectionStart, selectionEnd } = textarea;
    let result;

    if (format === "bold") {
      result = insertAroundSelection(text, selectionStart, selectionEnd, "**");
    } else if (format === "italic") {
      result = insertAroundSelection(text, selectionStart, selectionEnd, "_");
    } else if (format === "heading") {
      result = prefixSelectedLines(text, selectionStart, selectionEnd, () => "## ");
    } else if (format === "bullet") {
      result = prefixSelectedLines(text, selectionStart, selectionEnd, () => "- ");
    } else {
      result = prefixSelectedLines(text, selectionStart, selectionEnd, (index) => `${index + 1}. `);
    }

    onChange(result.nextText);
    requestAnimationFrame(() => {
      textarea.focus();
      textarea.setSelectionRange(result.cursorStart, result.cursorEnd);
    });
  };

  return (
    <div>
      <ButtonGroup size="sm" className="mb-2" aria-label="Description formatting">
        <Button variant="outline-secondary" type="button" onClick={() => applyFormat("heading")}>
          H
        </Button>
        <Button variant="outline-secondary" type="button" onClick={() => applyFormat("bold")}>
          B
        </Button>
        <Button variant="outline-secondary" type="button" onClick={() => applyFormat("italic")}>
          I
        </Button>
        <Button variant="outline-secondary" type="button" onClick={() => applyFormat("bullet")}>
          Bullets
        </Button>
        <Button variant="outline-secondary" type="button" onClick={() => applyFormat("numbered")}>
          1. List
        </Button>
      </ButtonGroup>
      <Form.Control
        id="task-description-editor"
        as="textarea"
        rows={8}
        placeholder={"Write clear instructions...\n\n## Requirements\n- First point\n- Second point\n\n1. Step one\n2. Step two"}
        required
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
      />
      <Form.Text className="text-muted">
        Supports headings, bullet lists, numbered lists, bold, and italic using simple Markdown.
      </Form.Text>
    </div>
  );
}
